<!--
 * @Author: wsx
 * @Date: 2022-01-05 18:45:47
 * @LastEditTime: 2022-01-12 18:03:34
 * @LastEditors: your name
 * @Description:地图选择摄像头
-->
<template>
  <div class="mapSelectTransfer">
    <MyMap ref="mapRef" @drawArea="getDrawArea">
      <template v-slot:back>
        <el-button @click="opertionBack">返回</el-button>
      </template>
    </MyMap>
    <div class="mapCameraList">
      <el-collapse>
        <el-collapse-item name="1" title="区域列表">
          <template #title>
            <div class="map-list-header">
              <span
                >已选择资源列表：（{{ selectPoint.length }}/{{
                  cameraPointNum
                }}）</span
              >
              <i @click.stop="deleteAlllist" class="iconfont icon-shanchu"></i>
            </div>
          </template>
          <div class="map-list-content">
            <div
              class="map-list-item"
              v-for="item in selectPoint"
              :key="item.cameraId"
            >
              <span class="map-list-name" :title="item.cameraName">{{
                item.cameraName
              }}</span>

              <i
                class="iconfont icon-shanchu"
                @click="deleteListItem(item)"
              ></i>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>
<script >
import {
  defineComponent,
  reactive,
  toRefs,
  nextTick,
  ref,
  watchEffect,
  onMounted,
} from "vue";
import util from "@util/js";
import { ElMessageBox } from "element-plus";
import handleCoordinates from "@/components/map/js/modular/handleCoordinates";
import MyMap from "@/components/map/MyMap.vue";
import { getDict } from "@/api/constant";
import { queryAllTreeAreaVideo } from "@/api/videoControl/videoApi.js";
export default defineComponent({
  name: "mapSelectTransfer",
  components: { MyMap },
  props: {
    //权限所有摄像机
    allCameraList: {
      type: Object,
      default: [],
    },
    //区域绑定摄像机
    tranferCameraList: {
      type: Object,
      default: [],
    },
  },
  setup(props, context) {
    const state = reactive({
      showHitClass: false,
      selectPoint: [], //绘制区域后的摄像机
      cameraPointNum: 0, //摄像机数
      mapCameraList: [], //地图展示摄像机
      selectTypeList: [],
    });
    const refData = toRefs(state);
    const mapRef = ref();
    const { setPoint, reversePoint, setVideoPoint, reverseVideoPoint } =
      handleCoordinates();
    watchEffect(() => {
      state.mapCameraList = props.allCameraList;
      state.selectPoint = props.tranferCameraList;
    });
    // 获取数据字典
    const queryMenuType = async () => {
      const res = await getDict("camera_inout_type");
      state.selectTypeList = res.dict;
    };
    //展示地图操作按钮
    const getDrawArea = (value) => {
      console.log(value);
      if (mapRef.value) {
        let videoPoint = [];
        state.selectPoint = [];
        // 获取所有点位坐标
        videoPoint = state.mapCameraList.map((element) => {
          element.location = [
            parseFloat(element.longitude),
            parseFloat(element.latitude),
          ];
          return element;
        });
        let selectPolygonPoint = [];
        let selectCirclPoint = [];
        value.forEach((element) => {
          if (!element.radius) {
            let selectPolygon = videoPoint.filter((item) => {
              let changeValue = element.corrdinates[0].map((el) => {
                return reverseVideoPoint(el);
              });
              if (util.isInsidePolygon(item.location, changeValue)) {
                return item;
              }
            });
            selectPolygonPoint.push(...selectPolygon);
          } else {
            selectCirclPoint = videoPoint.filter((item) => {
              element.loc = reverseVideoPoint(element.corrdinates);
              if (
                mapRef.value.getDistanceApi(item.location, element.loc) <
                element.radius
              ) {
                return item;
              }
            });
          }
          state.selectPoint = selectPolygonPoint.concat(selectCirclPoint);
        });
        if (state.selectPoint.length > 0) {
          //去重
          state.selectPoint = state.selectPoint.filter(
            (element, index, self) => {
              return (
                self.findIndex((x) => x.deviceId === element.deviceId) === index
              );
            }
          );
        }
      }
    };
    //添加接口中数据点位
    const pointInfoArray = (list) => {
      let array = list.filter((item) => {
        if (item.longitude && item.latitude) {
          item.location = setVideoPoint([
            Number(item.longitude),
            Number(item.latitude),
          ]);
          return item;
        }
      });
      state.cameraPointNum = array.length;
      let newList = array.map((element, index) => {
        let pointInfo = {
          name: "",
          item: element,
          id: 1,
          type: 1,
          showType: 2,
          poiType: 3401,
          location: element.location,
          click: (e) => {},
        };
        pointInfo.id = index + 1;
        return pointInfo;
      });
      nextTick(() => {
        mapRef.value && mapRef.value.loadMarker(newList);
        mapRef.value && mapRef.value.opertionBtn();
      });
    };
    const deleteAlllist = () => {
      if (state.selectPoint.length == 0) return;
      ElMessageBox.confirm("您确认要删除所有摄像头吗？", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(
        () => {
          state.selectPoint = [];
        },
        () => {}
      );
    };
    const deleteListItem = (value) => {
      state.selectPoint = state.selectPoint.filter((item) => {
        return item.cameraName != value.cameraName;
      });
      context.emit("update:tranferCameraList", state.selectPoint);
    };
    //退出地图
    const opertionBack = () => {
      context.emit("opertionBack", state.selectPoint);
    };
    queryMenuType();
    setTimeout(() => {
      pointInfoArray(props.allCameraList);
    }, 300);
    return {
      ...refData,
      mapRef,
      getDrawArea,
      deleteAlllist,
      deleteListItem,
      opertionBack,
    };
  },
});
</script>
<style  lang='scss' scoped >
.mapSelectTransfer {
  width: 100%;
  height: 100%;
  position: relative;
  .mapCameraList {
    position: absolute;
    width: 280px;

    z-index: 10;
    left: 0;
    top: 0;
    background: #fff;
    i {
      color: red;
      margin-right: 8px;
      cursor: pointer;
    }
    .map-list-header {
      height: 34px;
      padding: 0 8px;
      width: 100%;
      @include flex-row-sb-c;
    }
    .map-list-content {
      overflow: auto;
      height: calc(50vh - 150px);
      .map-list-item {
        padding: 0 8px;
        @include flex-row-sb-c;
        .map-list-name {
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}
</style>